/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Plus16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            d="M9 7h4.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H9v4.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V9H2.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H7V2.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5V7z"
            fill={vars.bdlGray50}
            fillRule="evenodd"
        />
    </AccessibleSVG>
);

export default Plus16;
